import moment from 'moment-timezone';

import type {UserReportApiResponse} from '~/shared/services/apiService/models';

export const isAllowedToStepBackward = (
  userCreated?: UserReportApiResponse['userCreated'],
  currentReportStartDate?: string,
  currentReportEndDate?: string,
): boolean => {
  if (!currentReportStartDate || !currentReportEndDate || !userCreated) {
    return false;
  }

  const startDate = moment(currentReportStartDate, 'DD/MM/YYYY');
  const endDate = moment(currentReportEndDate, 'DD/MM/YYYY');

  const isDifferentMonth = !startDate.isSame(endDate, 'month');
  const isDifferentYear = !startDate.isSame(endDate, 'year');
  if (isDifferentMonth || isDifferentYear) {
    return false;
  }

  const userCreatedDate = moment(userCreated);
  if (!userCreatedDate) {
    return false;
  }

  const isSameMonth = userCreatedDate.isSame(startDate, 'month');
  const isSameYear = userCreatedDate.isSame(startDate, 'year');
  return !(isSameMonth && isSameYear);
};
